import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * Listens for auth state changes and navigates accordingly.
 * - On SIGNED_IN: Navigate to /app (unless already there)
 * - On SIGNED_OUT: Navigate to landing page (unless on public routes)
 */
export function AuthListener() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session) {
        // Only navigate if not already in app
        if (!location.pathname.startsWith('/app')) {
          navigate('/app', { replace: true });
        }
      } else if (event === 'SIGNED_OUT') {
        // Only redirect to landing if currently in protected app area
        if (location.pathname.startsWith('/app') && location.pathname !== '/app/share') {
          navigate('/', { replace: true });
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate, location.pathname]);

  return null;
}
